
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SidePanelItemBlock extends Vue {
  @Prop({ default: false }) readonly showChevron: boolean | undefined;
  @Prop({ default: '2rem' }) readonly padding: string | undefined;
}
